export default __webpack_public_path__ + "static/media/haxl.e6cfe0c0.svg";